import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';

import { getMeetingsByDate } from '.././api';

const Codes = ( betting, agency ) => {
	const codeClass = classNames({
		tab: agency === 'tab',
		ubet: agency === 'ubet',
		"flex1 code": true,
	})

	let code = '';

	betting.forEach(i => {
		if (i.agency === agency) { code = i.betcode; }
	});

	if (code !== '') {
		return (
			<div className="codes">
				<button className={codeClass}>{code}</button>
			</div>
		);
	} else {
		return (<div></div>);
	}
};
Codes.propTypes = {
	betting: PropTypes.array,
};

const Meeting = ({ item, agency }) => {
	const { id, venue, risa, date, state, rail, weather, rating, disabled, betting } = item;

	const meetingClass = classNames({
		meeting: true,
	});

	const holdClass = classNames({
		'fa fa-lg fa-fw fa-lock disabled': disabled === true,
	})

	const risaUrl = `${moment(date).format('YYYYMMMDD')},${state},${risa}`;

	const venueClick = event => {
		if (event.shiftKey) {
			window.open(`https://www.racingaustralia.horse/FreeFields/GearChanges.aspx?Key=${risaUrl}&BodyClass=PrintFriendly`, '_blank');
		} else {
			window.open(`https://www.racingaustralia.horse/FreeFields/Scratchings.aspx?Key=${risaUrl}&BodyClass=PrintFriendly`, '_blank');
		}
	};

	const weatherIcon = classNames({
		fa: true,
		'fa-2x': true,
		'fa-sun-o fa-slow-spin yellow': weather === 'Fine',
		'fa-cloud': weather === 'Overcast', 
	});

	return (
		<div className={meetingClass}>
			<div className="flex1 centre">
			<span
				onClick={() => window.open(`https://editor.medialityracing.com.au/meeting/${id}`)}
			><i className="fa fa-pencil-square-o" aria-hidden="true"></i></span>
			</div>
			<div className="flex3">{Codes(betting, agency)}</div>
			<div className="flex8">				
				<button onClick={venueClick}>
					{venue}
					<i className={holdClass} title="Meeting is on hold!"></i>
				</button>
			</div>
			<div className="flex3 centre">{state}</div>
			<div className="flex3 centre"><i className={weatherIcon} aria-hidden="true"></i></div>
			<div className="flex20">{rail}</div>
			<div className="flex2 left"></div>
			<div className="flex4 left">{rating}</div>
		</div>
	);
};
Meeting.propTypes = {
	item: PropTypes.object,
	agency: PropTypes.string,
};

const Meetings = ({ meetings, agency }) => {
	
	const filtered = meetings.sort((a, b) => {
		if (a.venue > b.venue) return 1;
		if (a.venue < b.venue) return -1;
		return 0;
	});

	return (
		<div className="meeting-container">
			{filtered.map(item =>
				<Meeting key={item.id} item={item} agency={agency} />
			)}
		</div>
	);
};
Meetings.propTypes = {
	meetings: PropTypes.array,
};

const updating = () => dispatch =>
	dispatch({
		type: 'updating/meetings',
	});

class MeetingList extends Component {
	componentDidMount() {
		this.props.updating();
		this.props.load(this.props.date);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.date !== this.props.date) {
			this.props.updating();
			this.props.load(this.props.date);
		}
	}

	render() {
		if (this.props.progressCheck.meetings === true) return (<div>Loading...</div>);
		return Meetings({ ...this.props });
	}
}
MeetingList.propTypes = {
	updating: PropTypes.func,
	load: PropTypes.func,
	date: PropTypes.string,
	data: PropTypes.object,
	agency: PropTypes.string,
	progressCheck: PropTypes.object,
};

MeetingList = connect(
	({ meetings, progressCheck, agency }, { date }) => ({ meetings, progressCheck, agency, date }),
	{ load: getMeetingsByDate, updating },
)(MeetingList);

export default MeetingList;



/** WEBPACK FOOTER **
 ** ./src/components/meetings.jsx
 **/